import { Route as ProductProfitabilityRoute } from "@/routes/(inventory)/branch/_layout/reports/product-profitablity/index";
import { useQuery } from "@tanstack/react-query";
import { getProductProfitability } from "../-data/api";

interface ReportQueryResult {
  items: any[];
  totalCount: number;
  page: number;
  pageSize: number;
}

export const useProductProfitabilityData = () => {
  const searchParams = ProductProfitabilityRoute.useSearch();
  
  return useQuery<ReportQueryResult>({
    queryKey: ["product-profitability", searchParams],
    queryFn: async () => {
      const response = await getProductProfitability(searchParams.page || 1, searchParams.pageSize || 10);
      return {
        items: response.productProfitabilityItems,
        totalCount: response.totalCount,
        page: searchParams.page || 1,
        pageSize: searchParams.pageSize || 10,
      };
    },
    placeholderData: (previousData) => previousData,
    refetchOnWindowFocus: false,
    staleTime: 5 * 60 * 1000,
    gcTime: 10 * 60 * 1000,
  });
};